import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { FilterService } from '../services/filters.service';
import { FiltersComponent } from '../filters.component';
import { Subscription } from 'rxjs';
import { PedidoFilterService } from '../services/pedidos-filter.service';

@Component({
  selector: 'app-filtro-desktop',
  imports: [CommonModule, MatSidenavModule, FiltersComponent, MatExpansionModule],
  templateUrl: './filtro-desktop.component.html',
  styleUrl: './filtro-desktop.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class FiltroDesktopComponent implements OnInit {
  filtroAberto: boolean = false;
  filtroPedidosAberto: boolean = false;
  private sub!: Subscription;
  private subFiltroPedidos!: Subscription;

  constructor(
    private filterService: FilterService,
    private pedidoFilterService: PedidoFilterService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.load();
  }


  load() {
    this.sub = this.filterService.filtroAberto$.subscribe(aberto => {
      this.filtroAberto = aberto;
    });

    this.subFiltroPedidos = this.pedidoFilterService.filtroAberto$.subscribe(aberto => {
      this.filtroPedidosAberto = aberto;
    });
    this.cdr.detectChanges();
  }

  fecharDrawer() {
    this.filterService.fechar();
  }


}
